<template>
    <div class="board_category_wrap">
        <ul ref="boardCategoryUl" @click="foldUl">
            <li v-for="(category, idx) in cateData.mainCate" :key="idx"
                :class="+this.$route.query.cid === +category.cid || +this.$route.query.rootCid === +category.cid ? 'selected' : ''">
                <router-link
                    :to="{ path: $route.path, query: { ...$route.query, cid: category.cid, rootCid: category.cid,keyword:'',searchType: '',page: 1} }">{{
                        category.name
                    }}
                    <span class="dorp_arrow">
                        <img src="@/assets/history_dropdown.png" alt=""
                            v-if="+this.$route.query.cid === +category.cid || +this.$route.query.rootCid === +category.cid" />
                    </span>
                </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        cateData: {},
        selectedCate: {},
    },
    methods: {
        foldUl() {
            this.$refs.boardCategoryUl.classList.toggle('fold')
        }
    },
};
</script>
<style lang="scss" scoped>
.board_category_wrap {
    background: var(--gray2);
    margin-bottom: 50px;

    @media screen and (max-width: 768px) {
        margin-bottom: 30px;
    }

    ul {
        display: flex;

        @media screen and (max-width: 1280px) {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            overflow: hidden;
        }

        @media screen and (max-width: 768px) {
            grid-template-columns: 1fr;

            &.fold {
                height: auto;
                li {
                    position: relative;

                    &.selected {
                        a {
                            .dorp_arrow {
                                img {
                                    transform: rotate(180deg);
                                    transform-origin: center;
                                }
                            }
                        }
                    }
                }
            }

            height: 50px;
        }

        li {
            list-style: none;
            position: relative;
            height: 70px;
            flex: 1 0 0;

            @media screen and (max-width: 768px) {
                width: 100%;
                height: 50px;
                z-index: 0;
                order: 2;

                &:first-child {
                    background-color: #fafafa;
                    z-index: 1;
                }
            }

            a {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                color: var(--black2);
                font-size: 16px;
                font-weight: 400;
            }

            &::after {
                content: '';
                width: 1px;
                height: 20px;
                background: var(--border-color3);
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);

                @media screen and (max-width: 1280px) {
                    display: none;
                }
            }

            &.selected {
                background: var(--orange);

                @media screen and (max-width: 768px) {
                    z-index: 1;
                    order: 1;
                }

                a {
                    color: var(--white);
                    font-weight: 600;
                    position: relative;

                    .dorp_arrow {
                        display: none;
                    }

                    @media screen and (max-width: 768px) {
                        .dorp_arrow {
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            position: absolute;
                            top: 50%;
                            right: 5%;
                            transform: translateY(-50%);
                            filter: brightness(0) invert(1);
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                }
            }

            &.selected,
            &:last-child {
                &::after {
                    display: none;
                }
            }
        }
    }
}
</style>
